const isStaticFieldType = fieldType => ['TITLE', 'SUBTITLE', 'PARAGRAPH', 'DIVIDER'].includes(fieldType);

const abbreviate = s => s.length > 25 ? s.substring(0, 25) + '...' : s;

const fieldDescription = field => {
  if (field.fieldType === 'TITLE' || field.fieldType === 'SUBTITLE' || field.fieldType === 'PARAGRAPH') {
    return abbreviate(field.text || '');
  } else if (field.fieldType === 'DIVIDER') {
    return 'Divider';
  } else {
    return abbreviate(field.label || field.placeholder || field.helpText || '');
  }
};

const fieldService = {
  fieldDescription,
  isStaticFieldType,
};
export default fieldService;
